const pl = (action) =>
  window.dispatchEvent(new CustomEvent('calypso:plantillas', { detail: action }))

// Cambios de UI ANTES de avanzar (el elemento del siguiente paso aún no existe)
const pause = (fn, ms = 450) => setTimeout(fn, ms)

// Avanza PRIMERO y cambia la UI DESPUÉS, para que el elemento resaltado
// no desaparezca mientras el globo todavía lo está señalando
const go = (driver, dir, after, delay = 250) => {
  if (dir === 'next') driver.moveNext()
  else driver.movePrevious()
  setTimeout(() => {
    after?.()
    setTimeout(() => driver.refresh(), 150)
  }, delay)
}

// Paso del formulario de plantilla: escucha cuando el usuario guarda o cancela
let formDoneHandler = null
const quitarFormDone = () => {
  if (formDoneHandler) {
    window.removeEventListener('calypso:plantillas-form-done', formDoneHandler)
    formDoneHandler = null
  }
}

export function getMovimientosSteps({ type, t, openImport, closeImport }) {
  const k = type === 'income' ? 'ing' : 'gas'

  return [
    {
      element: '[data-tour="mov-total"]',
      popover: { title: t(`tour_${k}_total_t`), description: t(`tour_${k}_total_d`), side: 'bottom', align: 'start' }
    },
    {
      element: '[data-tour="mov-mes"]',
      popover: { title: t('tour_mes_t'), description: t('tour_mes_d') }
    },
    {
      element: '[data-tour="mov-form"]',
      popover: { title: t(`tour_${k}_form_t`), description: t(`tour_${k}_form_d`) }
    },
    {
      element: '[data-tour="mov-importar"]',
      popover: {
        title: t('tour_import_t'),
        description: t('tour_import_d'),
        onNextClick: (el, step, { driver }) => {
          openImport()
          pause(() => driver.moveNext())
        }
      }
    },
    {
      element: '[data-tour="mov-importar-panel"]',
      popover: {
        title: t('tour_pais_t'),
        description: t('tour_pais_d'),
        onPrevClick: (el, step, { driver }) => go(driver, 'prev', closeImport),
        onNextClick: (el, step, { driver }) => go(driver, 'next', closeImport)
      }
    },
    {
      element: '[data-tour="mov-plantillas"]',
      popover: {
        title: t('tour_plantillas_t'),
        description: t('tour_plantillas_d'),
        side: 'top',
        onPrevClick: (el, step, { driver }) => {
          openImport()
          pause(() => driver.movePrevious())
        },
        onNextClick: (el, step, { driver }) => {
          pl('open')
          pause(() => driver.moveNext(), 600)
        }
      }
    },
    {
      element: '[data-tour="pl-nueva"]',
      popover: {
        title: t('tour_pl_nueva_t'),
        description: t('tour_pl_nueva_d'),
        onPrevClick: (el, step, { driver }) => go(driver, 'prev', () => pl('close')),
        onNextClick: (el, step, { driver }) => {
          pl('new')
          pause(() => driver.moveNext())
        }
      }
    },
    {
      element: '[data-tour="pl-form"]',
      disableActiveInteraction: false, // aquí el usuario SÍ puede escribir
      onHighlightStarted: (el, step, { driver }) => {
        quitarFormDone()
        const idx = driver.getActiveIndex()
        formDoneHandler = () => {
          quitarFormDone()
          // Guardó o canceló: pasamos solo a la lista (si no se movió de paso)
          setTimeout(() => {
            if (driver.getActiveIndex() === idx) driver.moveNext()
          }, 700)
        }
        window.addEventListener('calypso:plantillas-form-done', formDoneHandler)
      },
      onDeselected: () => quitarFormDone(),
      popover: {
        title: t('tour_pl_form_t'),
        description: t('tour_pl_form_d'),
        onPrevClick: (el, step, { driver }) => {
          pl('cancelForm')
          pause(() => driver.movePrevious())
        },
        onNextClick: (el, step, { driver }) => go(driver, 'next', () => pl('cancelForm'))
      }
    },
    {
      element: '[data-tour="pl-lista"]',
      popover: {
        title: t('tour_pl_lista_t'),
        description: t('tour_pl_lista_d'),
        onPrevClick: (el, step, { driver }) => {
          pl('new')
          pause(() => driver.movePrevious())
        }
      }
    },
    {
      element: '[data-tour="pl-agregar"]',
      popover: {
        title: t('tour_pl_agregar_t'),
        description: t('tour_pl_agregar_d'),
        onNextClick: (el, step, { driver }) => go(driver, 'next', () => pl('close'))
      }
    },
    {
      element: '[data-tour="mov-filtro"]',
      popover: {
        title: t('tour_filtro_t'),
        description: t('tour_filtro_d'),
        onPrevClick: (el, step, { driver }) => {
          pl('open')
          pause(() => driver.movePrevious(), 600)
        }
      }
    },
    {
      element: '[data-tour="mov-lista"]',
      popover: { title: t(`tour_${k}_lista_t`), description: t(`tour_${k}_lista_d`) }
    }
  ]
}